import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  SquareSection,
  TitleTabContainer,
  TabsWrapper,
  GridWrapper,
  TitleWrapper,
  TitleContent,
  TitleContainer,
  Card,
  TagSection,
  IconSection,
  Question,
  IconContent,
  Tag,
} from './styled.viewSkeleton';

export function ViewSkeleton () {
  const listSkeleton: number[] = [0, 1, 2];

  return (
    <>
      {/* SCORE */}
      <SquareSection>
        <div>
          <Skeleton width={64} height={64} borderRadius={8} />
        </div>
        <div>
          <Skeleton width={64} height={64} borderRadius={8} />
        </div>
        <Skeleton width={1} height={64} />
        <div>
          <Skeleton width={64} height={64} borderRadius={8} />
        </div>
        <div>
          <Skeleton width={64} height={64} borderRadius={8} />
        </div>
        <div>
          <Skeleton width={64} height={64} borderRadius={8} />
        </div>
      </SquareSection>
      {/* TABS */}
      <TabsWrapper>
        <TitleTabContainer>
          <Skeleton width={64} />
        </TitleTabContainer>
        <TitleTabContainer>
          <Skeleton width={64} />
          <Skeleton width={64} />
          <Skeleton width={64} />
          <Skeleton width={64} />
          <Skeleton width={64} />
        </TitleTabContainer>
      </TabsWrapper>
      {/* CONTENT TAB */}
      <div>
        <TitleContainer>
          <Skeleton width={84} />
          <Skeleton width={54} />
        </TitleContainer>
        <GridWrapper>
          <TitleWrapper>
            <TitleContent>
              <Skeleton width={54} />
            </TitleContent>
            <Skeleton width={54} />
          </TitleWrapper>
          <div>
            <Skeleton width={54} />
          </div>
        </GridWrapper>
      </div>
      {/* QUESTION CARD */}
      <div>
        {listSkeleton.map((index) => (
          <Card key={index}>
            <TagSection>
              <Tag>
                <Skeleton width={55} borderRadius={8} />
              </Tag>
            </TagSection>
            <Question>
              <Skeleton count={3} />
            </Question>
            <IconSection>
              <IconContent>
                <div>
                  <Skeleton width={40} height={40} borderRadius={4} />
                </div>
                <div>
                  <Skeleton width={40} height={40} borderRadius={4} />
                </div>
                <div>
                  <Skeleton width={40} height={40} borderRadius={4} />
                </div>
              </IconContent>
              <div>
                <div>
                  <Skeleton width={40} height={40} borderRadius={4} />
                </div>
              </div>
            </IconSection>
          </Card>
        ))}
      </div>
    </>
  );
}
